/**
 * HTTP layer for the QuickBooks accounting integration. OAuth handshake,
 * company/customer lookups, customer-association management, and invoice push.
 *
 * Contains:
 * - fetchQuickBooksCompany / fetchQuickBooksCustomers: QuickBooks reads
 * - fetchQuickBooksAuthorizationUrl / fetchQuickBooksOAuthCallback: OAuth handshake
 * - fetchQuickBooksCustomerAssociations / associateQuickBooksCustomer / disassociateQuickBooksCustomer: customer links
 * - createQuickBooksInvoice: push an invoice to QuickBooks
 */
import FileSaver from 'file-saver';

import apiClient from '@sophocles/http-common';

export const QUICKBOOKS_ENDPOINT = '/billing/quickbooks';

export const fetchQuickBooksCompany = () => apiClient.get(`${QUICKBOOKS_ENDPOINT}/status/`).then(res => res.data);

export const fetchQuickBooksAuthorizationUrl = () =>
  apiClient.get(`${QUICKBOOKS_ENDPOINT}/auth/`).then(res => res.data.auth_url);

export const fetchQuickBooksOAuthCallback = code =>
  apiClient.get(`${QUICKBOOKS_ENDPOINT}/callback?code=${code}`).then(res => res.data);

export const fetchQuickBooksCustomers = () =>
  apiClient.get(`${QUICKBOOKS_ENDPOINT}/customers/`).then(res => res.data.results);

export const fetchQuickBooksCustomerAssociations = accountId =>
  apiClient.get(`${QUICKBOOKS_ENDPOINT}/associations/${accountId}/`).then(res => res.data);

export const createQuickBooksInvoice = invoiceId =>
  apiClient.post(`${QUICKBOOKS_ENDPOINT}/invoices/`, { invoice_ids: [invoiceId] }).then(res => res.data);

export const associateQuickBooksCustomer = (quickBooksId, accountId, siteGroupId) => {
  const data = { intuit_customer_id: quickBooksId, account_id: accountId };
  if (siteGroupId) {
    data.site_group_id = siteGroupId;
  }
  return apiClient.post(`${QUICKBOOKS_ENDPOINT}/associate/`, data).then(res => res.data);
};

export const disassociateQuickBooksCustomer = siteGroupId => {
  const data = { site_group_id: siteGroupId };
  return apiClient.post(`${QUICKBOOKS_ENDPOINT}/disassociate/`, data).then(res => res.data);
};
